// extracted by css-extract-rspack-plugin
export default {"wrapper":"gte_xM06ukQpCh97","error_not_dealer":"gRWXHWPVYUoGNBi6"};